const handleAddToCart = () => {
  const forms = document.querySelectorAll('form.add-to-cart-container');
  
  forms.forEach(form => {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      
      const button = form.querySelector('.add-to-cart-button');
      const spinner = form.querySelector('.loading-spinner');
      const buttonText = form.querySelector('.button-text');

      // Show loading state
      button.disabled = true;
      spinner.classList.remove('hidden');
      buttonText.textContent = 'Adding...';

      try {
        const formData = new FormData(form);
        
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: new URLSearchParams(formData)
        });

        if (response.ok) {
          buttonText.textContent = 'Added to cart';
          
          // Get updated cart data
          const cartResponse = await fetch('/cart.js');
          
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            
            if (typeof _cartUpdateCartCount2 !== 'undefined' && _cartUpdateCartCount2['default']) {
              _cartUpdateCartCount2['default']();
            }
            
            // Dispatch cart:added event
            document.dispatchEvent(new CustomEvent('cart:added'));
            
            // Open cart drawer using theme's function
            if (window.wetheme && window.wetheme.drawer) {
              window.wetheme.drawer._toggleRightDrawer('cart', true, { cart: cart });
            }
          }
        } else {
          const data = await response.json();
          buttonText.textContent = 'Error - Try again';
        }
      } catch (error) {
        buttonText.textContent = 'Error - Try again';
        console.error('Add to cart error:', error);
      } finally {
        spinner.classList.add('hidden');
      }
    });
  });
};

// Initialize on DOM load
document.addEventListener('DOMContentLoaded', handleAddToCart);